import { render, staticRenderFns } from "./ServicesContainer.vue?vue&type=template&id=9dd91740&scoped=true&"
import script from "./ServicesContainer.vue?vue&type=script&lang=js&"
export * from "./ServicesContainer.vue?vue&type=script&lang=js&"
import style0 from "./ServicesContainer.vue?vue&type=style&index=0&id=9dd91740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd91740",
  null
  
)

export default component.exports